module.exports = __webpack_public_path__ + "img/vi.vi75fc073.svg";